<template>
  <div>
      <fields-list />
  </div>
</template>

<script>
import FieldsList from './FieldsList.vue';

export default {
  name: "FieldsLayout",
  components: {
      FieldsList,
  },
}
</script>

<style scoped>

</style>